import { render, staticRenderFns } from "./SurveyTerms.vue?vue&type=template&id=6320488b&scoped=true&"
import script from "./SurveyTerms.vue?vue&type=script&lang=js&"
export * from "./SurveyTerms.vue?vue&type=script&lang=js&"
import style0 from "./SurveyTerms.vue?vue&type=style&index=0&id=6320488b&lang=scss&scoped=true&"
import style1 from "./SurveyTerms.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6320488b",
  null
  
)

export default component.exports